import { render, staticRenderFns } from "./PasoDosComponent.vue?vue&type=template&id=51325ea1&scoped=true"
import script from "./PasoDosComponent.vue?vue&type=script&lang=js"
export * from "./PasoDosComponent.vue?vue&type=script&lang=js"
import style0 from "./PasoDosComponent.vue?vue&type=style&index=0&id=51325ea1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51325ea1",
  null
  
)

export default component.exports